<template>
  <div>
    <menu-content-container v-if="rolesStore.arePermissionsEnabled" border-full>
      <content-row>
        <TSwitch
          v-model="isLockedComputed"
          data-testid="lock-content"
          :disabled="!canLockBlocks"
          :label="$t('forms.lock_block')"
          :tooltip="$t('forms.cannot_unlock_block')"
        ></TSwitch>
      </content-row>
    </menu-content-container>

    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { useRolesStore } from "@/stores/roles";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TSwitch } from "@topol/twig-ui";
  import { computed } from "vue";

  const props = defineProps({
    isLocked: {
      type: Boolean,
      required: true,
    },

    canLockBlocks: {
      type: Boolean,
      required: true,
    },
  });

  const rolesStore = useRolesStore();
  const mjmlStore = useMjmlStore();

  const isLockedComputed = computed({
    get() {
      return props.isLocked;
    },

    set() {
      mjmlStore.toggleBlockLock();
    },
  });
</script>
